import { render, staticRenderFns } from "./RejectedGroupRequestList.vue?vue&type=template&id=d14c42ba"
import script from "./RejectedGroupRequestList.vue?vue&type=script&lang=js"
export * from "./RejectedGroupRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports